import React from 'react'

import { ZariContext } from '_zari/context'
import { Col, Row, Portlet, Button } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as PresupuestoNuevoServices from 'services/presupuestoNuevo.service'

const BaseCuentaContable = () => {
  const __zariContext = React.useContext(ZariContext)

  const clickDescargarReporte = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte presupuesto cuenta contable')
    PresupuestoNuevoServices.descargarReporteBaseCuentaContable()
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <Portlet className='zari-slim-form'>
      <Portlet.Header title='Reporte Presupuesto Cuentas Contables' />
      <Portlet.Body>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(BaseCuentaContable)
